import { render, staticRenderFns } from "./PostAssignments.vue?vue&type=template&id=765fda8d&scoped=true&"
import script from "./PostAssignments.vue?vue&type=script&lang=js&"
export * from "./PostAssignments.vue?vue&type=script&lang=js&"
import style0 from "./PostAssignments.vue?vue&type=style&index=0&id=765fda8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765fda8d",
  null
  
)

export default component.exports